<template>
  <ValidationObserver ref="questionTemplateForm">
    <div class="mt-4">
      <ValidationProvider v-slot="{ errors }" rules="required">
        <Select
          :disabled="editMode"
          v-model="applicationQuestionTemplateData.inputType"
          :items="typeOptions"
          label="Type"
          placeholder=""
          :error-messages="getErrorMessages(errors)"
        />
      </ValidationProvider>
      <ValidationProvider v-slot="{ errors }" rules="required">
        <v-text-field
          :error-messages="getErrorMessages(errors)"
          label="Title"
          class="mb-4 mt-2"
          v-model="applicationQuestionTemplateData.question"
        />
      </ValidationProvider>
      <v-label>Subtitle (optional)</v-label>
      <v-textarea
        class="mt-0"
        aria-label="Description"
        v-model="applicationQuestionTemplateData.explanation"
        hide-details
      />
      <v-checkbox
        type="checkbox"
        hide-details
        label="Is a screening question"
        v-model="applicationQuestionTemplateData.required"
        class="shrink mt-0 py-6"
      />
      <ValidationProvider v-slot="{ errors }" rules="required|notEmpty">
        <Select
          v-model="applicationQuestionTemplateData.terms"
          :items="tags"
          :loading="isFetchingTags"
          label="Set"
          multiple
          :error-messages="getErrorMessages(errors)"
        />
      </ValidationProvider>
      <AnswerOptions
        :options="applicationQuestionTemplateData.options"
        v-if="showAnswerOptions"
        ref="answerOptions"
      />
      <ValidationProvider v-slot="{ errors }" rules="minNumber:0">
        <v-text-field
          label="Character Limit (optional)"
          class="mb-4 mt-2"
          type="number"
          v-model="applicationQuestionTemplateData.characterLimit"
          :error-messages="getErrorMessages(errors)"
        />
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { merge, isEmpty, includes } from "lodash";
import Select from "@/components/common/Select";
import { createNamespacedHelpers } from "vuex";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { FETCH_TAGS } from "@/store/modules/data/actions";
import { GET_TAGS, GET_IS_FETCHING_TAGS } from "@/store/modules/data/getters";
import AnswerOptions from "./answers/AnswerOptions";
import { TYPE_OPTIONS, TYPES_WITH_OPTIONS } from "@/constants/questions";

const {
  mapActions: mapDataActions,
  mapGetters: mapDataGetters
} = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Select,
    AnswerOptions
  },
  props: {
    applicationQuestionTemplate: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      applicationQuestionTemplateData: {
        required: false,
        inputType: "",
        question: "",
        explanation: "",
        characterLimit: null,
        terms: []
      },
      showValidationErrors: false,
      typeOptions: TYPE_OPTIONS,
      typesWithOptions: TYPES_WITH_OPTIONS,
      editMode: false
    };
  },
  created() {
    this.fetchTags({
      filter: {
        taxonomy: "application_questions"
      }
    });
    if (!isEmpty(this.applicationQuestionTemplate)) {
      this.editMode = true;
      this.adjustapplicationQuestionTemplateData();
    }
  },
  computed: {
    ...mapDataGetters({
      tags: GET_TAGS,
      isFetchingTags: GET_IS_FETCHING_TAGS
    }),
    showAnswerOptions() {
      return includes(
        this.typesWithOptions,
        this.applicationQuestionTemplateData.inputType
      );
    }
  },
  methods: {
    ...mapDataActions({
      fetchTags: FETCH_TAGS
    }),
    adjustapplicationQuestionTemplateData() {
      this.applicationQuestionTemplateData = merge(
        this.applicationQuestionTemplateData,
        this.applicationQuestionTemplate
      );
    },
    close() {
      this.$emit("close");
    },
    async validateForm() {
      let isFormValid = false;
      let areOptionsValid = true;
      this.showValidationErrors = true;
      isFormValid = await this.$refs.questionTemplateForm.validate();
      if (this.showAnswerOptions) {
        areOptionsValid = await this.$refs.answerOptions.validate();
      }
      if (isFormValid && areOptionsValid) {
        this.$emit("onSubmit", {
          ...this.applicationQuestionTemplateData,
          characterLimit:
            this.applicationQuestionTemplateData.characterLimit || null,
          ...(this.showAnswerOptions && {
            optionsTemplate: this.$refs.answerOptions.allOptions
          })
        });
      }
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    }
  }
};
</script>

<style lang="scss"></style>
